import React from 'react';

import { PianoRollSvgLayer } from './PianoRollSvgLayer';

const PianoRollPendingNote = ({
   lowNote,
   highNote,
   noteHeight,
   beatCount,
   partsPerBeat,
   partWidth,
   pendingNote,
   onMousemove,
}) => {
   const gridHeight = (highNote - lowNote + 1) * noteHeight;
   const gridWidth = beatCount * partsPerBeat * partWidth;

   const x = pendingNote.startPart * partWidth;
   const y = (pendingNote.note - highNote) * -1 * noteHeight;

   return (
      <PianoRollSvgLayer
         width={gridWidth}
         height={gridHeight}
         onMouseMove={(e) => onMousemove(e.clientX, e.clientY)}
      >
         {pendingNote && (
            <g>
               <rect
                  className="pending-note-highlight"
                  x={0}
                  y={y}
                  width={beatCount * partsPerBeat * partWidth}
                  height={noteHeight}
               />

               {pendingNote.noteLength == null ? (
                  <polygon
                     className="pending-note"
                     points={`${x},${y} ${x + (partsPerBeat / 4) * partWidth},${
                        y + noteHeight / 2
                     } ${x},${y + noteHeight}`}
                  />
               ) : (
                  <rect
                     className="pending-note"
                     x={x}
                     y={y}
                     width={partWidth * pendingNote.noteLength}
                     height={noteHeight}
                  />
               )}
            </g>
         )}
      </PianoRollSvgLayer>
   );
};

export { PianoRollPendingNote };
